import avatar from '../../../static/images/avatar.png'

export default function Avatar({style}){
    return(
        <a href='https://gitlab.com/sedrin880' target="blank" style={{overflow: 'hidden', borderRadius: '50%', display: 'flex', ...style}}>
            <img alt="" src={avatar} style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
        </a> 
    )
}